const AUTH_CACHE_KEY = 'prodyt_auth_cache';

export const saveAuthToStorage = (userDetail) => {
    try {
        localStorage.setItem(AUTH_CACHE_KEY, JSON.stringify(userDetail));
    } catch (error) {
        console.error('Failed to save auth to localStorage:', error);
    }
};

export const getAuthFromStorage = () => {
    try {
        const cached = localStorage.getItem(AUTH_CACHE_KEY);
        return cached ? JSON.parse(cached) : null;
    } catch (error) {
        console.error('Failed to get auth from localStorage:', error);
        return null;
    }
};

export const clearAuthFromStorage = () => {
    try {
        localStorage.removeItem(AUTH_CACHE_KEY);
    } catch (error) {
        console.error('Failed to clear auth from localStorage:', error);
    }
};
